import { IntroIFrame, IntroWrapper } from '../__intro-elements';
import { IntroKeys } from '../intro-keys';

import styles from '../_intro.module.scss';

const AddTag1 = () => (
  <IntroWrapper>
    <p>Quickly seek the player for the best moments in the file..</p>
  </IntroWrapper>
);

const AddTag2 = () => (
  <IntroWrapper size="medium">
    <p>
      When you find a highlight, seek to its beginning and tag it. <strong>No need to tag the end</strong>, the Pulse
      Storyboard will take care of that.
    </p>
  </IntroWrapper>
);

const AddTag3 = () => (
  <IntroWrapper size="medium">
    <p>
      Pulse is designed to help users <b>edit very quickly</b>. The most time consuming part of editing uncut source
      footage is finding the highlights.
    </p>
    <p>
      Seek the player to find and tag the beginning of the highlights in each of your files. Tag as many as you like -
      these will become clips on the Storyboard.
    </p>
    <IntroIFrame src="https://www.youtube.com/embed/zIsXryrl_q0" />
  </IntroWrapper>
);

export const TUTS_ADD_TAG = [
  { element: `[data-intro="${IntroKeys.srSeek}"]`, intro: <AddTag1 /> },
  { element: `[data-intro="${IntroKeys.srAddClip}"]`, intro: <AddTag2 /> },
  {
    element: `[data-intro="${IntroKeys.srAddClip}"]`,
    intro: <AddTag3 />,
    tooltipClass: styles.LengthenCell,
    position: 'bottom',
  },
];
